<template lang="html">
  <div
    class="modal"
    :class="{'is-open': isOpen}"
    @click="closeIfPossible">
    <div class="modal-container" @click.stop>
      <div class="modal-header">
        <h2 v-if="title" class="modal-title">{{title}}</h2>
        <slot name="header">
          <button
            type="button"
            class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
            v-on:click="close">
            <span class="css-icon is-close"></span>
          </button>
        </slot>
      </div>
      <div class="modal-content">
        <slot name="content"></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: 'SimpleModal',
  components: {
  },
  filters: {
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    canClose: {
      type: Boolean,
      default: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    closeIfPossible() {
      if (this.canClose) {
        this.close();
      }
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>
